export default __webpack_public_path__ + "static/media/hero.cdb98ef3.png";